import { CF_PREFIX } from '@/constants/initiative'

const removeCfPrefix = name => (name.startsWith(CF_PREFIX) ? name.substr(CF_PREFIX.length) : name)

export default field => +removeCfPrefix(field)
